
import { NgModule }             from '@angular/core';
import { Routes,RouterModule } from '@angular/router';

import { ShareModule} from '../shared/share.module';

import { AuthComponent } from './auth.component';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { AuthSignupComponent } from './auth-signup/auth-signup.component';
import { AuthForgetPasswordComponent } from './auth-forget-password/auth-forget-password.component';
import { AuthChangePasswordComponent } from './auth-change-password/auth-change-password.component';

const modules: NgModule[] =[ShareModule]; 

@NgModule({
    declarations: [
    AuthComponent,AuthLoginComponent,AuthSignupComponent,AuthForgetPasswordComponent,AuthChangePasswordComponent
  ],
  imports: [modules, RouterModule.forChild([
      {path:'auth',component:AuthComponent,children:[
          {path:'login',component:AuthLoginComponent},
          {path:'signup',component:AuthSignupComponent},
          {path:'forget',component:AuthForgetPasswordComponent},
          {path:'changePassword/:id',component:AuthChangePasswordComponent}
          ]}
  ]) ],
  exports: [ RouterModule,modules ]
})
export class AuthModule {}


// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts